import {
  Box,
  Button,
  ColumnConfig,
  DataTable,
  Layer,
  Text,
  TextInput,
} from "grommet";
import { Observer, observer } from "mobx-react";
import React, { useEffect, useState } from "react";
import { useStore } from "../../../../../Hooks/useStore";
import { toJS } from "mobx";
import { Mixpanel } from "../../../../../util/Helper";
import DisableSidebar from "../../../../../assets/close_small.svg";
import { userStore } from "../../../../../store/UserStore";
import "./DisableRightBar.css";
import usersService from "../../screens/IAM/Users/users.service";

type DisableRightBarProps = {
  show: boolean;
  onCancel: () => void;
  onDone: () => void;
  title: string;
  typingValidationText: string;
  confimButtonText: string;
};
function DisableRightSideBar({
  show,
  onCancel,
  onDone,
  title,
  typingValidationText,
  confimButtonText,
}: DisableRightBarProps) {
  const [inputValue, setInputValue] = useState("");

  const handleInputChange = (event: any) => {
    setInputValue(event.target.value);
  };
  const handleSubmit = () => {
    console.log("Form submitted with value:", inputValue);
  };

  const { rootStore } = useStore();
  // const handleUserShowDisableConfirmation = () => {
  //   this.userShowDisableConfirmation = newVal;
  // }

  return (
    <Layer
      className="disable-user-sidebar-container"
      style={{
        borderRadius: "12px 0px 0px 0px",
        width: "500px",
        height: "100%",
      }}
      full="vertical"
      position="right"
      // onEsc={() => {
      //     Mixpanel.track("web close " + submitButtonTitle);
      //     onCancel();
      // }}
    >
      <Box
        fill
        style={{
          minWidth: "378px",
          borderRadius: "12px 0px 0px 0px",
          maxWidth: "500px",
        }}
        flex
        flex-start
        direction="column"
        align="center"
      >
        <Box
          style={{
            borderRadius: "12px 0px 0px 0px",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
          direction="column"
          as="header"
          background={"#E9F2FF"}
          width="100%"
          pad={"small"}
        >
          <Text
            style={{
              color: "#4B628A",
              fontFamily: "Inter",
              fontSize: "16px",
              fontStyle: "normal",
              fontWeight: "600",
              lineHeight: "20px",
            }}
          >
            Confirm
          </Text>
          {/* <Button 
        style={{color: "#357EFF",
          fontFamily: "Inter",
          fontSize: "14px",
          fontStyle: "normal",
          fontWeight: "600",
          lineHeight: "16px"}} onClick={() => {
            Mixpanel.track("web close " );
            onCancel();
          }} ><img src={closeActionSidebar} style={{width: 20, height: 20}}/>Close</Button> */}
          <Button
            style={{
              color: "#357EFF",
              fontFamily: "Inter",
              fontSize: "14px",
              fontStyle: "normal",
              fontWeight: "600",
              lineHeight: "16px",
            }}
            onClick={() => {
              rootStore.adminStore.handleDeleteConformation(false);
            }}
          >
            <img src={DisableSidebar} style={{ width: 20, height: 20 }} />
            Close
          </Button>
        </Box>
        <Box className="disable-user-middle-container">
          <Box
            style={{
              borderRadius: "12px 0px 0px 12px",
              background: "#FFF",
              display: "inline-flex",
              flexDirection: "column",
              alignItems: "flex-start",
              gap: "16px",
            }}
          >
            <Text
              style={{
                color: "#4B628A",
                fontFamily: "Inter",
                fontSize: "16px",
                fontStyle: "normal",
                fontWeight: "500",
                lineHeight: "22px",
              }}
            >
              Are you sure you want to delete the selected role?
            </Text>
            <Text
              style={{
                color: "#4B628A",
                fontFamily: "Inter",
                fontSize: "16px",
                fontStyle: "normal",
                fontWeight: "700",
                lineHeight: "22px",
              }}
            >
              Please type <span style={{ fontWeight: "600" }}>‘DELETE’</span> in
              the field below to confirm.
            </Text>
            <TextInput
              type="password"
              placeholder="Enter Here"
              style={{
                color: "#333",

                fontFeatureSettings: "'clig' off, 'liga' off",
                fontFamily: "Inter",
                fontSize: "14px",
                fontStyle: "normal",
                fontWeight: "500",
                lineHeight: "22px",
                display: "flex",
                padding: "13px 15px",
                alignItems: "flex-start",
                gap: "10px",
                alignSelf: "stretch",
                borderRadius: "10px",
                background: "#F2F8FF",
                width: "84%",
                boxShadow: "unset",
                border: "none",
              }}
              onChange={handleInputChange}
            />
          </Box>
          <Box className="disable-user-btn">
            <Button
              style={{
                color: "#357EFF",
                display: "flex",
                width: "120px",
                padding: "14px 49px",
                justifyContent: "center",
                alignItems: "center",
                gap: "10px",
                borderRadius: "10px",
                border: "1px solid #357EFF",
                background: "#FFF",
              }}
              onClick={onCancel}
              label="Cancel"
            />
            <Button
              label="Confirm"
              className={`myButton ${
                inputValue.toLowerCase() === typingValidationText.toLowerCase()
                  ? "active"
                  : "disabled"
              }`}
              onClick={onDone}
              disabled={
                inputValue.toLowerCase() !== typingValidationText.toLowerCase()
              }
            />
          </Box>
        </Box>
      </Box>
    </Layer>
  );
}

export default observer(DisableRightSideBar);
